





import React from "react";
import "../../styles/Timberline.css";
import timberImage from "../../images/timber-slider.jpg";
import timber1 from "../../assets/timber1.jpg";
import timber2 from "../../assets/timber2.jpg";
import timberIcon from "../../assets/service-icon.png"; // Import the timber icon
import { Link } from "react-router-dom";

const Timberline = () => {
  return (
    <div className="timber-container">
      {/* Image Slider - Full width like homepage */}
      <div className="timber-image-slider">
        <img src={timberImage} alt="Timberline Slider" />
      </div>

      {/* Main Content Container */}
      <div className="timber-content">
        {/* Content Card with title inside */}
        <div className="timber-card">
          {/* Title with Icon - Added with blue style */}
          <div className="timber-title-header">
            <img src={timberIcon} alt="Timber Service" className="timber-title-icon rotate-on-hover" />
            <h3 className="timber-title-text">Timberline</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="timber-image-container first-image">
              <img src={timber1} alt="Timber Loading" className="timber-img" />
            </div>
            <div className="timber-image-container second-image">
              <img src={timber2} alt="Timber Transport" className="timber-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="timber-text">
              Established to cater to the Indian timber importers, Timberline, in a period of a few years, has 
              shipped several million cft of timber logs to India. With vessel capacities varying from 4500MT 
              DWCC to 22,000MT DWCC, the Line has established itself as a major service provider to the Indian 
              timber industry.
            </p>
            <p className="timber-text">
              Timberline's regular sailing routes are from Malaysia, Indonesia and the remote Solomon Islands 
              to Calcutta, Vizag, Chennai, Tuticorin, Mangalore and Kandla.
            </p>
            <p className="timber-text">
              Puyvast is in the process of introducing regular services also from Africa, Australia and New Zealand 
              to the sub-continent, to further serve the timber industry.
            </p>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63090KA1997PTC022102</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Timberline;